import GenericCtiAdaptor from './genericcti.adaptor'
import Zendesk from './integration.bridge/zendesk'
import { authorizeTalkdesk } from './authorization/authorize.talkdesk'

export default class ZendeskV3Adaptor extends GenericCtiAdaptor {
  constructor (...args) {
    super('zendesk', ...args)
  }

  importVendor () {
    const bridge = new Zendesk()

    return new Promise((resolve) => {
      resolve(bridge)
    })
  }

  getSubdomain (vendor) {
    return vendor.getSubdomain()
  }

  onOpenTicket (data, vendor, mp, capabilities) {
    vendor.onOpenTicket(data, mp, capabilities)
  }

  onAdaptorReady (vendor) {
    this.getSubdomain(vendor).then(accountName => {
      this.accountName = accountName
      authorizeTalkdesk(this.name, this.accountName)
    })
  }
}
